import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import { useEffect, useState } from 'react';
import UseContext from 'hooks/useContext';
import UseModal from 'components/modal/useModal';
import ApiDatabase from 'server';
import Button from 'components/button';
import ModalBody from 'components/modal/components/body';
import ModalFooter from 'components/modal/components/footer';
import Modalheader from 'components/modal/components/header';
import { formatFileSize } from 'helper/justificatifFile';

/**
 * The client's written request behind one change (JBWEB-1211 / JBWEB-1214).
 *
 * Rendered with the same viewer the identity documents use, so a PDF and a
 * photographed mail both open the way every other document in the admin does.
 *
 * The link is fetched when the modal opens and never stored with the entry:
 * it is a short-lived signature over a client document, and one that outlives
 * the click is one that can be passed on.
 */
const ModalCompanyActivityJustificatif = () => {
  const { toggle } = UseModal();
  const { modalData } = UseContext();
  const [docs, setDocs] = useState([]);
  const [fileName, setFileName] = useState(null);
  const [size, setSize] = useState(null);
  const [isWaiting, setIsWaiting] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('xsrfToken');

  useEffect(() => {
    if (!modalData?.idLog) return;

    setIsWaiting(true);
    ApiDatabase.getCompanyActivityJustificatif(
      { token, idLog: modalData.idLog },
      (data) => {
        setIsWaiting(false);
        if (!data?.url) {
          setError("Le justificatif est introuvable.");
          return;
        }
        setFileName(data.originalName ?? 'Justificatif');
        setSize(data.size ?? modalData?.size ?? null);
        setDocs([
          {
            uri: data.url,
            fileName: data.originalName ?? 'Justificatif',
            // The viewer picks its renderer from this, and the API answers
            // with the type it read from the file's own bytes.
            fileType: data.mimetype ?? 'application/pdf',
          },
        ]);
      },
      (err) => {
        setIsWaiting(false);
        if (err.name === 'CanceledError') return;
        console.error(err);
        setError("Le justificatif n'a pas pu être ouvert.");
      }
    );
  }, [modalData?.idLog, modalData?.size, token]);

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Justificatif de modification client
      </Modalheader>
      <ModalBody>
        <div className={'flex flex-col gap-3'}>
          {fileName && (
            <div className={'text-gray-500 ft-sm'}>
              {fileName}
              {Number.isFinite(size) ? ` · ${formatFileSize(size)}` : ''}
            </div>
          )}

          {error ? (
            <div className={'text-red-500'}>{error}</div>
          ) : isWaiting ? (
            <div className={'space-y-3'}>
              <div className={'h-4 w-1/3 skeleton-bar'} />
              <div className={'h-[400px] w-full skeleton-bar'} />
            </div>
          ) : docs.length > 0 ? (
            <DocViewer
              documents={docs}
              style={{ maxHeight: 700, pdfVerticalScrollByDefault: true }}
              pluginRenderers={DocViewerRenderers}
            />
          ) : (
            <div
              className={
                'flex justify-center items-center h-full py-3 px-1 border rounded'
              }
            >
              <div className={'text-gray-500'}>Aucun document à afficher.</div>
            </div>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
          Fermer
        </Button>
      </ModalFooter>
    </>
  );
};

export default ModalCompanyActivityJustificatif;
